import { SocialLoginOption } from "@redotech/redo-model/auth/social-auth";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const convertSocialAuthToCustomerAuth = {
  name: "convertSocialAuthToCustomerAuth" as const,
  input: z.object({
    provider: createEnum(SocialLoginOption),
    code: z.string(),
  }),
  output: z.object({
    error: z.string().nullable(),
    customerAuthToken: z.string().optional(),
    customer: z
      .object({ name: z.string(), email: z.string(), customerId: z.string() })
      .optional(),
    orderId: z.string().optional(),
    warrantyId: z.string().optional(),
  }),
};
